import {pushGoogleTag} from '../@helper/common/common';
import {getPlanSubscribe} from '../@helper/common/common';


export const setMetrics = () => {

    const selectedPlan = getPlanSubscribe();
    const subscriptionCost = selectedPlan.cost;


    const googleData = {
        event: 'autoEvent',
        eventCategory: 'Web Subscription Page',
        eventAction: 'Order Placed',
        eventValue: subscriptionCost,
        ecommerce: {
            purchase: {
                actionField: {
                    revenue: subscriptionCost,
                },
                products: [
                    {
                        name: selectedPlan.plan,
                        SKU: selectedPlan.plan,
                        price: subscriptionCost,
                        quantity: 1
                    }
                ]
            }
        }
    };

    const successShown = {
        event:'autoEvent',
        eventCategory:'Web Subscription Page',
        eventAction: 'Success Screen Shown'
    };


    pushGoogleTag(googleData);
    pushGoogleTag(successShown);
};
